<template>
    <v-container class="pa-5" fluid>
        <StatusHistoryDialog
            :request-status-history="requestStatusHistory"
            :is-open="statusHistoryDialog"
            @close-status-history-dialog="closeStatusHistoryDialog"
        />
        <AssignHistoryDialog
            :request-assign-history="requestAssignHistory"
            :is-open="assignHistoryDialog"
            @close-assign-history-dialog="closeAssignHistoryDialog"
        />
        <ConfirmDialog
            :is-open="assignUserDialog"
            :data="request"
            :action-loading="actionLoading.assignUser"
            @on-confirm="assignCurrentUser"
            @on-abort="closeConfirmAssignUserDialog"
        >
            <template #title>
                Przypisanie zapotrzebowania #{{ request.id }}
            </template>
            <template #content>
                Czy na pewno chcesz przypisać zapotrzebowanie do siebie?
            </template>
            <template #confirmButton>
                Potwierdź
            </template>
        </ConfirmDialog>
        <ConfirmDialog
            :is-open="deleteRequestDialog"
            :data="request"
            removal
            :action-loading="requestLoadingOnDelete"
            @on-confirm="deleteRequest"
            @on-abort="closeDeleteRequestDialog"
        >
            <template #title>
                Usuwanie zapotrzebowania #{{ request.id }}
            </template>
            <template #content>
                Czy na pewno chcesz usunąć zapotrzebowanie?
            </template>
            <template #confirmButton>
                Usuń
            </template>
        </ConfirmDialog>
        <page-title>Zapotrzebowania</page-title>
        <v-row align="center">
            <v-col cols="12" sm="8" lg="4">
                <v-btn
                    color="secondary"
                    medium
                    data-sentry-label="Dodaj kampanię"
                    :loading="requestLoading"
                    @click="createRequest"
                >
                    <v-icon left>
                        mdi-plus
                    </v-icon>
                    Dodaj zapotrzebowanie
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-container fluid class="pa-0">
                    <v-row justify="end" dense>
                        <v-col cols="12" md="4" lg="3">
                            <v-autocomplete
                                v-model="filters.createdBy_id"
                                :items="creators"
                                :filter="customUsersFilter"
                                :loading="usersSearchCreatorLoading"
                                :search-input.sync="usersSearchCreator"
                                label="Zgłaszający..."
                                class="v-text-field--placeholder-dark"
                                required
                                solo
                                hide-details
                                item-value="id"
                                no-data-text="Nie znaleziono"
                                clearable
                                @keyup.enter="changeFilter"
                                @input="changeFilter"
                                @click:clear="clearFilter('createdBy_id')"
                            >
                                <template slot="no-data">
                                    <v-list-item>
                                        <v-list-item-title>
                                            <template v-if="!usersSearchCreator">
                                                Wpisz treść aby odnaleźć <strong>zgłaszającego</strong>.
                                            </template>
                                            <template v-else-if="usersSearchCreatorLoading">
                                                Trwa wyszukiwanie...
                                            </template>
                                            <template v-else>
                                                Nie znaleziono zgłaszającego na zapytanie: "<strong> {{ usersSearchCreator }}".</strong>
                                            </template>
                                        </v-list-item-title>
                                    </v-list-item>
                                </template>
                                <template slot="selection" slot-scope="data">
                                    <template v-if="data.item.firstName && data.item.lastName">
                                        {{ data.item.firstName }} {{ data.item.lastName }}
                                    </template>
                                    <template v-else>
                                        {{ data.item.username }}
                                    </template>
                                </template>
                                <template slot="item" slot-scope="data">
                                    <template v-if="data.item.firstName && data.item.lastName">
                                        {{ data.item.firstName }} {{ data.item.lastName }}
                                    </template>
                                    <template v-else>
                                        {{ data.item.username }}
                                    </template>
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="4" lg="3">
                            <v-autocomplete
                                v-model="filters.assignedTo_id"
                                :items="assigned"
                                :filter="customUsersFilter"
                                :loading="usersSearchAssignedLoading"
                                :search-input.sync="usersSearchAssigned"
                                label="Przypisany..."
                                class="v-text-field--placeholder-dark"
                                required
                                solo
                                hide-details
                                item-value="id"
                                no-data-text="Nie znaleziono"
                                clearable
                                @keyup.enter="changeFilter"
                                @input="changeFilter"
                                @click:clear="clearFilter('assignedTo_id')"
                            >
                                <template slot="no-data">
                                    <v-list-item>
                                        <v-list-item-title>
                                            <template v-if="!usersSearchAssigned">
                                                Wpisz treść aby odnaleźć <strong>przypisanego</strong>.
                                            </template>
                                            <template v-else-if="usersSearchAssignedLoading">
                                                Trwa wyszukiwanie...
                                            </template>
                                            <template v-else>
                                                Nie znaleziono przypianego na zapytanie: "<strong> {{ usersSearchAssigned }}".</strong>
                                            </template>
                                        </v-list-item-title>
                                    </v-list-item>
                                </template>
                                <template slot="selection" slot-scope="data">
                                    <template v-if="data.item.firstName && data.item.lastName">
                                        {{ data.item.firstName }} {{ data.item.lastName }}
                                    </template>
                                    <template v-else>
                                        {{ data.item.username }}
                                    </template>
                                </template>
                                <template slot="item" slot-scope="data">
                                    <template v-if="data.item.firstName && data.item.lastName">
                                        {{ data.item.firstName }} {{ data.item.lastName }}
                                    </template>
                                    <template v-else>
                                        {{ data.item.username }}
                                    </template>
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="6" lg="3">
                            <v-select
                                v-model="filters.status_id"
                                :items="requestStatuses"
                                item-value="id"
                                label="Wybierz status..."
                                no-data-text="Brak danych..."
                                clearable
                                hide-details
                                solo
                                @change="changeFilter"
                            >
                                <template slot="selection" slot-scope="data">
                                    {{ data.item.name }}
                                </template>

                                <template slot="item" slot-scope="data">
                                    {{ data.item.name }}
                                </template>
                            </v-select>
                        </v-col>
                        <v-col cols="12" md="8" lg="3">
                            <v-text-field
                                v-model="filters.title"
                                append-icon="mdi-magnify"
                                label="Szukaj..."
                                single-line
                                clearable
                                hide-details
                                solo
                                @keyup.enter="changeFilter"
                                @click:append="changeFilter"
                                @click:clear="clearFilter('title')"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-data-table
                        :headers="requestsHeaders"
                        :items="requests"
                        :loading="requestsLoading"
                        :footer-props="footerProps"
                        :server-items-length="pagination.itemsLength"
                        :page.sync="pagination.page"
                        :items-per-page.sync="pagination.itemsPerPage"
                        :mobile-breakpoint="0"
                        name="requestsData"
                        @pagination="updatePagination"
                    >
                        <template #item="{item}">
                            <tr :class="{'isSelected': selectedRequestId == item.id}">
                                <td :class="requestLabelClass(item.statusId)">
                                    <v-tooltip v-if="!isLoggedUserAssigned(item.assignedTo)" :open-delay="tooltipDelay" top>
                                        <template #activator="{on}">
                                            <v-btn
                                                icon
                                                data-sentry-label="Przypisz do mnie"
                                                :disabled="!canEditRequest"
                                                v-on="on"
                                                @click="showConfirmAssignUserDialog(item)"
                                            >
                                                <v-icon
                                                    color="blue"
                                                >
                                                    mdi-account-check
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Przypisz do mnie</span>
                                    </v-tooltip>
                                </td>
                                <td>
                                    {{ item.id }}
                                </td>
                                <td>
                                    {{ item.title }}
                                </td>
                                <td>
                                    {{ item.requestType.name }}
                                </td>
                                <td>
                                    {{ item.status.name }}
                                </td>
                                <td>
                                    {{ formatDate(item.createdAt) }}
                                </td>
                                <td>
                                    <template v-if="item.createdBy.firstName && item.createdBy.lastName">
                                        {{ item.createdBy.firstName }} {{ item.createdBy.lastName }}
                                    </template>
                                    <template v-else>
                                        {{ item.createdBy.username }}
                                    </template>
                                </td>
                                <td>
                                    <template v-if="item.assignedTo">
                                        <template v-if="item.assignedTo.firstName && item.assignedTo.lastName">
                                            {{ item.assignedTo.firstName }} {{ item.assignedTo.lastName }}
                                        </template>
                                        <template v-else>
                                            {{ item.assignedTo.username }}
                                        </template>
                                    </template>
                                    <template v-else>
                                        -
                                    </template>
                                </td>
                                <td>
                                    <div class="d-inline-flex">
                                        <v-tooltip :open-delay="tooltipDelay" top>
                                            <template #activator="{on}">
                                                <v-btn
                                                    icon
                                                    data-sentry-label="Dodaj zapytanie"
                                                    :disabled="externalRequestLoading"
                                                    v-on="on"
                                                    @click="createExternalRequest(item.id)"
                                                >
                                                    <v-icon color="blue">
                                                        mdi-plus
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Dodaj zapytanie</span>
                                        </v-tooltip>
                                        <v-tooltip :open-delay="tooltipDelay" top>
                                            <template #activator="{on}">
                                                <v-btn
                                                    icon
                                                    data-sentry-label="Historia przypisań"
                                                    v-on="on"
                                                    @click="getRequestAssignHistory(item.id)"
                                                >
                                                    <v-icon color="indigo lighten-1">
                                                        mdi-account-clock-outline
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Historia przypisań</span>
                                        </v-tooltip>
                                        <v-tooltip :open-delay="tooltipDelay" top>
                                            <template #activator="{on}">
                                                <v-btn
                                                    icon
                                                    data-sentry-label="Historia statusów"
                                                    v-on="on"
                                                    @click="getRequestStatusHistory(item.id)"
                                                >
                                                    <v-icon color="blue-grey">
                                                        mdi-history
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Historia statusów</span>
                                        </v-tooltip>
                                        <v-tooltip :open-delay="tooltipDelay" top>
                                            <template #activator="{on}">
                                                <v-btn
                                                    icon
                                                    data-sentry-label="Edytuj"
                                                    v-on="on"
                                                    @click="editRequest(item.id)"
                                                >
                                                    <v-icon color="teal">
                                                        mdi-pencil
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Edytuj</span>
                                        </v-tooltip>
                                        <v-tooltip :open-delay="tooltipDelay" top>
                                            <template #activator="{on}">
                                                <v-btn
                                                    icon
                                                    data-sentry-label="Usuń"
                                                    v-on="on"
                                                    @click="showDeleteRequestDialog(item.id)"
                                                >
                                                    <v-icon color="pink">
                                                        mdi-delete
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Usuń</span>
                                        </v-tooltip>
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import router from '@/router'

import PageTitle from '@/components/common/PageTitle'
import ConfirmDialog from '@/components/common/ConfirmDialog'
import StatusHistoryDialog from './StatusHistoryDialog'
import AssignHistoryDialog from './AssignHistoryDialog'

import pagination from '@/mixins/dataTablePagination'
import tooltipDelay from '@/mixins/tooltip'
import customFilters from '@/mixins/customFilters'
import dateFormatter from '@/mixins/dateFormatter'
import filters from '@/mixins/dataTableFilters'
import dataTableClassSetter from '@/mixins/dataTableClassSetter'

import { hasUserPermission } from '@/utils/permissionsHandler'
import { errorHandler, addSentryBreadcrumb } from '@/utils/errorHandler'


let searchTimer

export default {
    name: 'RequestsList',
    components: {
        PageTitle, AssignHistoryDialog, StatusHistoryDialog, ConfirmDialog
    },
    mixins: [
        dateFormatter,
        pagination,
        tooltipDelay,
        filters,
        customFilters,
        dataTableClassSetter
    ],
    beforeRouteLeave(to, from, next) {
        if (!this.filtersCleared) {
            this.$store.dispatch('purchases/clearRequestFilters')
            this.clearSelectedListItemId()
        }
        this.resetFiltersCleared()
        next()
    },
    data() {
        return {
            usersSearchCreator: null,
            usersSearchCreatorLoading: false,
            usersSearchAssigned: null,
            usersSearchAssignedLoading: false,
            creators: [],
            assigned: [],
            request: {
                id: null,
                requestTypeId: null,
                content: null,
                materialName: null,
                materialWeight: null,
                externalRequestNumber: null,
                providerName: null,
                deliveryDate: null,
                atStock: false,
                assignedTo: null
            },
            requestLoading: false,
            externalRequestLoading: false,
            deleteRequestDialog: false,
            requestLoadingOnDelete: false,
            assignUserDialog: false,
            actionLoading: {
                assignUser: false
            },
            requestStatusHistory: [],
            requestAssignHistory: [],
            statusHistoryDialog: false,
            assignHistoryDialog: false,
            requestsHeaders: [
                {
                    value: 'assign',
                    sortable: false,
                },
                {
                    text: 'ID',
                    value: 'id',
                    sortable: false,
                    width: 100
                },
                {
                    text: 'Tytuł',
                    value: 'title',
                    sortable: false,
                    width: 160
                },
                {
                    text: 'Typ zapotrzebowania',
                    value: 'requestType',
                    sortable: false,

                },
                {
                    text: 'Status',
                    value: 'status',
                    sortable: false,
                },
                {
                    text: 'Data złożenia',
                    value: 'createdAt',
                    sortable: false,
                },
                {
                    text: 'Zgłaszający',
                    value: 'createdBy',
                    sortable: false,
                },
                {
                    text: 'Przypisany',
                    value: 'assignedTo',
                    sortable: false,
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                    width: 100
                }
            ],
        }
    },
    computed: {
        requestsLoading() {
            return this.$store.state.purchases.requests.requestsLoading
        },
        requestStatuses() {
            return this.$store.state.purchases.requests.requestStatuses
        },
        userId() {
            return this.$store.state.user.userId
        },
        requests() {
            return this.$store.state.purchases.requests.requests
        },
        canEditRequest() {
            return hasUserPermission('requests_update')
        },
        savedFilters() {
            return this.$store.state.purchases.requests.filters
        },
        selectedRequestId() {
            return this.$store.state.common.selectedListItemId
        },
        filterQuery() {
            const filters = Object.assign({}, this.filters)
            let query = ''

            for (let item in filters) {
                if (filters[item] != null && filters[item] != '') {
                    query = query.concat('&', `${item}=${filters[item]}`)
                }
            }

            return query
        }
    },
    watch: {
        usersSearchCreator(value = null) {
            if (value === null) return

            this.usersSearchCreatorLoading = true

            clearTimeout(searchTimer)

            searchTimer = setTimeout(() => {
                if (value) {
                    this.searchUsersCreator(value)
                } else {
                    this.usersSearchCreatorLoading = false
                    this.creators = []
                }
            }, 500)
        },
        usersSearchAssigned(value = null) {
            if (value === null) return

            this.usersSearchAssignedLoading = true

            clearTimeout(searchTimer)

            searchTimer = setTimeout(() => {
                if (value) {
                    this.searchUsersAssigned(value)
                } else {
                    this.usersSearchAssignedLoading = false
                    this.assigned = []
                }
            }, 500)
        }
    },
    beforeMount() {
        if (!this.savedPagination.pagination) {
            this.resetPagination()
        }
    },
    mounted() {
        this.getRequests()
        Promise.all([
            this.$store.dispatch('purchases/getRequestStatuses'),
        ])
            .catch(error => {
                errorHandler(error)
            })
    },
    methods: {
        closeStatusHistoryDialog() {
            this.statusHistoryDialog = false
        },
        getRequestStatusHistory(id) {
            this.$store.dispatch('purchases/getRequestStatusHistory', id)
                .then(response => {
                    this.requestStatusHistory = response.data.results
                    this.statusHistoryDialog = true
                }).catch(error => {
                    errorHandler(error)
                })
        },
        closeAssignHistoryDialog() {
            this.assignHistoryDialog = false
        },
        getRequestAssignHistory(id) {
            this.$store.dispatch('purchases/getRequestAssignHistory', id)
                .then(response => {
                    this.requestAssignHistory = response.data.results
                    this.assignHistoryDialog = true
                }).catch(error => {
                    errorHandler(error)
                })
        },
        showConfirmAssignUserDialog(item) {
            this.request = item
            this.assignUserDialog = true
        },
        closeConfirmAssignUserDialog() {
            this.assignUserDialog = false
            this.getRequests()

            setTimeout(() => {
                this.request = {}
            }, 500)
        },
        assignCurrentUser() {
            this.actionLoading.assignUser = true

            const payload = {
                id: this.request.id,
                assignedToId: this.userId
            }

            this.$store.dispatch('purchases/updateRequest', payload)
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading.assignUser = false
                    this.closeConfirmAssignUserDialog()
                })
        },
        getRequests() {
            this.$store.dispatch('purchases/getRequests', {
                paginate: this.paginate(),
                query: this.filterQuery
            })
                .then(response => {
                    this.handlePaginationResponse(response)
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        getRequest(requestId) {
            this.$store.dispatch('purchases/getRequest', requestId)
                .then(response => {
                    this.request = response.data
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        deleteRequest() {
            this.requestLoadingOnDelete = true
            this.$store.dispatch('purchases/deleteRequest', this.request.id)
                .then(() => {
                    this.closeDeleteRequestDialog()
                })
                .catch(error => {
                    this.closeDeleteRequestDialog()
                    errorHandler(error)
                })
                .finally(() => {
                    this.requestLoadingOnDelete = false
                })
        },
        createExternalRequest(requestId) {
            this.externalRequestLoading = true
            this.savePagination(this.$options.name)
            router.push({ name: 'purchasesRequestsExternalRequestCreate', params: { requestId: requestId } })
                .catch(error => {
                    errorHandler(error)
                })
        },
        editRequest(requestId) {
            this.savePagination(this.$options.name)
            this.saveFiltersCleared()
            this.setSelectedListItemId(requestId)
            router.push({ name: 'purchasesRequestsEdit', params: { id: requestId } })
                .catch(error => {
                    errorHandler(error)
                })
        },
        createRequest() {
            this.requestLoading = true
            router.push({ name: 'purchasesRequestsCreate' })
                .catch(error => {
                    errorHandler(error)
                })
        },
        showDeleteRequestDialog(requestId) {
            this.getRequest(requestId)
            this.deleteRequestDialog = true
        },
        closeDeleteRequestDialog() {
            this.deleteRequestDialog = false
            this.getRequests()
        },
        isLoggedUserAssigned(assignedTo) {
            if (assignedTo) {
                return assignedTo.id === this.userId
            }

            return false
        },
        requestLabelClass(value) {
            if (value === 10) {
                return 'v-data-table__label v-data-table__label--danger'
            }
        },
        changeFilter() {
            this.$store.dispatch('purchases/setRequestFilters', this.filters)
            this.resetPagination()
            this.getRequests()
        },
        searchUsersCreator(query = '') {
            addSentryBreadcrumb('ui.action', 'Wyszukiwanie użytkownika')

            this.$store.dispatch('administration/findUsers', {
                paginate: '?limit=20',
                query: query
            })
                .then(response => {
                    this.creators = response.data.results
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.usersSearchCreatorLoading = false
                })
        },
        searchUsersAssigned(query = '') {
            addSentryBreadcrumb('ui.action', 'Wyszukiwanie użytkownika')

            this.$store.dispatch('administration/findUsers', {
                paginate: '?limit=20',
                query: query
            })
                .then(response => {
                    this.assigned = response.data.results
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.usersSearchAssignedLoading = false
                })
        },
        updatePagination(pagination) {
            this.pagination = pagination
            this.evaluateSavedPagination(this.$options.name)
            if (pagination.pageCount !== 0 && !this.paginationSettings.paginationPending && !this.savedPagination.pagination) {
                this.getRequests()
            }
            this.clearPaginationPending()
        }
    }
}
</script>